module.exports = __webpack_public_path__ + "img/postman.f640b1ae.png";